import React from 'react';
import { GoogleLogin, useGoogleLogin } from '@react-oauth/google';
import { LinkButton } from '@/components/ui/Buttons';

type ButtonTypes = {
  userType: string,
  redirectUrl: string,
  classes?: string,
  switchAccounts?: boolean,
};

const Button = ({ redirectUrl, switchAccounts, userType, classes }: ButtonTypes) => {
  const redirect = () => {
    if (redirectUrl) {
      window.location.replace(`${redirectUrl}?google_ssi&user_type=${userType}`);
    } else {
      window.location.reload();
    }
  };

  const displayError = () => {
    $('#content_container')
      .prepend('<div id="flash" class="alert"><p>Something went wrong with Google Sign In<i class="fa fa-times pos_fr cursor_point" aria-hidden="true"></i></p></div>');
  };

  const postData = (response) => {
    jQuery.ajax({
      data: response,
      error: () => displayError(),
      success: () => redirect(),
      type: 'POST',
      url: '/oauth/google_sign_in',
    });
  };

  const login = useGoogleLogin({
    onError: displayError,
    onSuccess: async tokenResponse => postData(tokenResponse),
  });

  if (switchAccounts) {
    return (
      <div className={classes}>
        Not you?

        <LinkButton onClick={login}>
          Switch Accounts
        </LinkButton>
      </div>
    );
  }

  return (
    <div className="tw-flex tw-justify-center tw-pt-[10px] tw-leading-[1.2]">
      <GoogleLogin
        use_fedcm_for_button
        use_fedcm_for_prompt
        logo_alignment="center"
        width="206px"
        onError={() => {
          displayError();
        }}
        onSuccess={(credentialResponse) => {
          postData(credentialResponse);
        }}
      />
    </div>
  );
};

export default Button;
